"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const initialState = require("@nextcloud/initial-state");
function getCapabilities() {
  try {
    return initialState.loadState("core", "capabilities");
  } catch (error) {
    console.debug("Could not find capabilities initial state fall back to _oc_capabilities");
    if (!("_oc_capabilities" in window)) {
      return {};
    }
    return window["_oc_capabilities"];
  }
}
exports.getCapabilities = getCapabilities;
//# sourceMappingURL=index.cjs.map
